import { render, staticRenderFns } from "./CategoryInfos.vue?vue&type=template&id=0363cad4"
import script from "./CategoryInfos.vue?vue&type=script&lang=ts"
export * from "./CategoryInfos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports